import { useStore } from '../store';

/**
 * Who you are: path levels and the top things the reserve is known for, from the Sim-Core
 * `identity` projection. Path labels and knownFor labels are PROPOSED placeholder copy
 * (data/paths.json v2), not approved. Nothing here is derived client-side.
 */
const PATH_LABELS: Record<string, string> = {
  zoo: 'Zoo', hunting_ranch: 'Hunting ranch', conservation_breeder: 'Conservation breeder',
  rancher: 'Rancher', breeder: 'Breeder', conservationist: 'Conservationist',
};

const TRACKS: Record<string, string> = { zoo_public: 'Zoo public', hunters: 'Hunters', conservationists: 'Conservation', governments: 'Governments', ranchers: 'Ranchers', breeders: 'Breeders' };

export function IdentityPanel() {
  const { sim } = useStore();
  const id = sim.identity;
  if (!id) {
    return <div style="padding:6px 18px 16px"><div class="eyebrow eyebrow-rule">Who you are</div><p style="font-size:13px;color:var(--ui-ink-soft)">Your identity shows up once you start playing.</p></div>;
  }
  const active = id.paths.filter((p) => p.level > 0).length;
  return (
    <div style="padding:6px 18px 16px">
      <div class="eyebrow eyebrow-rule">Who you are</div>
      <div class="eyebrow" style="margin-top:10px">Known for</div>
      {id.knownFor.length === 0 && <div class="row-label" style="margin-top:6px">Nothing yet. Keep playing and a reputation forms.</div>}
      {id.knownFor.map((k) => (
        <div key={k.label} style="display:flex;align-items:center;gap:8px;margin-top:6px">
          <span class="stealth-label" style="width:128px;white-space:normal">{k.label}</span>
          <span class="stealth-bar" style="flex:1"><span class="stealth-fill" style={`width:${Math.max(0, Math.min(100, k.score))}%`} /></span>
          <span class="row-value" style="font-size:14px;width:28px;text-align:right">{k.score}</span>
        </div>
      ))}
      <div class="eyebrow" style="margin-top:14px">Paths {active > 1 ? '(mixed)' : ''}</div>
      {id.paths.map((p) => (
        <div key={p.id} style="margin-top:6px">
        <div style="display:flex;align-items:center;gap:8px">
          <span class="stealth-label" style="width:128px;white-space:normal">{PATH_LABELS[p.id] ?? p.id}</span>
          <span style="flex:1;display:flex;gap:4px">
            {[1, 2, 3, 4, 5].map((n) => (
              <span key={n} style={`flex:1;height:8px;border-radius:4px;background:${n <= p.level ? 'var(--ui-amber-deep)' : 'var(--ui-ink-faint)'}`} />
            ))}
          </span>
          <span class="row-value" style="font-size:14px;width:28px;text-align:right">{p.level}</span>
        </div>
        {p.gate && <div class="row-label" style="white-space:normal;margin-left:136px;text-transform:none;letter-spacing:0.01em">Needs {TRACKS[p.gate.track] ?? p.gate.track} {p.gate.need} to reach level {p.gate.level}</div>}
        </div>
      ))}
      <div class="row-label" style="white-space:normal;margin-top:8px">Paths can be mixed. Higher levels unlock more. Names are proposed placeholder text.</div>
    </div>
  );
}
